<textarea
  #textarea
  [title]="label"
  [attr.placeholder]="placeholder"
  [name]="name"
  [formControl]="control">
</textarea>
